class MFRProductTop {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      variantSelector: ".variant-selector",
      quantitySelector: ".quantity-selector",
      subscriptionSelector: ".subscription-selector",
      productImage: ".product-top__images-inner",
      form: ".product-top__form",
      price: ".product-top__submit .price",
      stickyTrigger: ".focus-sticky-component",
      removeStickyTrigger: ".remove-focus-sticky-component",
      subscriptionPrice:
        '[name="purchase_selector"][value="subscription"] + .subscription-selector__selector .subscription-selector__selector-price',
      oneTimePrice:
        '[name="purchase_selector"][value="one-time"] + .subscription-selector__selector .subscription-selector__selector-price',
      dynamicTexts: ".subscription-selector .dynamic-texts",
      sellingPlanSelector: "[name='selling_plan']",
      addToCart: "#sticky-bar-html",
      stickyBar: ".product-sticky-bar"
    };

    this.$lastElementFocus = "";

    this.init();
  }

  init() {
    this.$variantSelector = this.$element.find(this.selectors.variantSelector);
    this.$quantitySelector = this.$element.find(
      this.selectors.quantitySelector
    );
    this.$subscriptionSelector = this.$element.find(
      this.selectors.subscriptionSelector
    );
    this.$productImage = this.$element.find(this.selectors.productImage);
    this.$form = this.$element.find(this.selectors.form);
    this.$price = this.$element.find(this.selectors.price);
    this.$subscriptionPrice = this.$element.find(
      this.selectors.subscriptionPrice
    );
    this.$oneTimePrice = this.$element.find(this.selectors.oneTimePrice);
    this.$dynamicTexts = this.$element.find(this.selectors.dynamicTexts);
    this.$sellingPlanSelector = this.$element.find(
      this.selectors.sellingPlanSelector
    );

    this.$stickyBar = $(this.selectors.stickyBar);
    this.$stickyTrigger = this.$element.find(this.selectors.stickyTrigger);
    this.$removeStickyTrigger = $(this.selectors.removeStickyTrigger);
    this.$addToCart = $(this.selectors.addToCart);

    this.$variantSelector.on(
      "mfr:changed",
      this.__handleVariantChange.bind(this)
    );
    this.$quantitySelector.on(
      "mfr:quantity-changed",
      this.__handleQuantityChange.bind(this)
    );
    this.$subscriptionSelector.on(
      "mfr:subscription-changed",
      this.__handleSubscriptionChange.bind(this)
    );

    this.$stickyTrigger.on("click", this.focusStickyComponent.bind(this));
    this.$removeStickyTrigger.on("click", this.removeFocusStickyComponent.bind(this));

    //this.removeMutation();
    this.updatePriceSettings();
    this.updatePrice();
    this.initStickyBar();
    this.updateSubscriptionSelectorPrices();
    this.forceRemoveRCWidget();
    this.initDynamicTexts();
    this.toggleDescription();
    this.convertHiddenATCToText();
    this.positionPDPImage();
  }

  focusStickyComponent() {
    this.$lastElementFocus = this.$stickyTrigger
    trapFocus(document.querySelector('.product-sticky-bar'), document.querySelector('.quantity-selector__plus'))
  }

  removeFocusStickyComponent() {
    this.$lastElementFocus.focus()
    removeTrapFocus()
  }

  toggleDescription() {
    this.$element.find('.product-top__description .read-more-btn').on('click', function() {
      const $this = $(this);
      const $descShort = $this.siblings('.desc-short');
      const $descFull = $this.siblings('.desc-full');
      $descShort.toggle();
      $descFull.toggle();
      $this.text($this.text() === 'Read More' ? 'Read Less' : 'Read More');
    });
  }

  forceRemoveRCWidget() {
    const interval = setInterval(() => {
      if (this.$element.find(".rc-container-wrapper").length) {
        this.$element.find(".rc-container-wrapper").remove();
        clearInterval(interval);
      }
    }, 100);
  }

  initStickyBar() {
    if(window.showQuantitySelector === "false") {
      this.$stickyBar.find(".quantity-selector").addClass("visually-hidden");
    }
  }

  convertHiddenATCToText() {
    this.$addToCart.text(this.$addToCart.html());
  }

  initDynamicTexts() {
    if (!this.$dynamicTexts.length || !this.$sellingPlanSelector.length) return;

    this.$sellingPlanSelector.each((i, e) => {
      $(e).attr("data-index", i);
    });

    this.$dynamicTexts.each((i, e) => {
      const element = $(e);
      const texts = element.text().split("|");
      element.html("");
      element.data("dynamic-texts", texts);
    });

    this.setDynamicTextIndex(0);

    this.$sellingPlanSelector.on("change", (e) =>
      this.setDynamicTextIndex($(e.currentTarget).data("index"))
    );
  }

  setDynamicTextIndex(index) {
    if (!this.$dynamicTexts.length) return;

    this.$dynamicTexts.each((i, e) => {
      const element = $(e);
      element.data("current-index", index);
      element.html(`
        <span>${element.data("dynamic-texts")[index]}</span>
      `);
    });
  }

  __handleVariantChange(e, data) {
    if (this.$quantitySelector.length) {
      this.$quantitySelector.mfrQuantitySelector("set-quantity", 1);
      this.$quantitySelector.data("max", data.max);
    }
    const discount = this.$subscriptionSelector.length
      ? this.$subscriptionSelector.mfrSubscriptionSelector("get-discount")
      : 0;

    this.updatePriceSettings();
    this.updatePrice();
    this.updateSubscriptionSelectorPrices();
  }

  __handleQuantityChange(e, data) {
    this.updatePrice();
    this.updateSubscriptionSelectorPrices();
  }

  __handleSubscriptionChange(e, data) {
    this.updatePriceSettings();
    this.updatePrice();
    this.changeImageOnSubscriptionSelect();
  }

  removeMutation() {
    var observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes") {
          this.$price
            .closest(".add-to-cart")
            .removeAttr("data-price-mutation-watcher");
          this.$price.removeClass("recharge-inner-most-price");
          this.updatePrice();
        }
      });
    });

    observer.observe(this.$price.closest(".add-to-cart").get(0), {
      attributes: true, //configure it to listen to attribute changes
    });
    this.$element.find(".rc-container-wrapper").remove();
  }

  updateSubscriptionSelectorPrices() {
    if (!this.$subscriptionSelector.length) return;
    const basePrice = parseFloat(this.$form.data("base-price"));
    const discount =
      this.$subscriptionSelector.mfrSubscriptionSelector("get-discount");
    const subscription = this.$element.find(this.selectors.subscriptionPrice);
    const onetime = this.$element.find(this.selectors.oneTimePrice);
    const subscriptionPrice = basePrice - basePrice * discount;
    const oneTimePrice = this.$form.data("base-price");
    const quantity = this.$quantitySelector.length
      ? this.$quantitySelector.mfrQuantitySelector("get-quantity")
      : 1;
    const subscriptionHTML = `${
      subscription.html()[0]
    }${this.toFixedIfNecessary(subscriptionPrice * quantity, 2)}`;
    const onetimeHTML = `${onetime.html()[0]}${this.toFixedIfNecessary(
      oneTimePrice * quantity,
      2
    )}`;
    subscription.attr(
      "data-base-price",
      oneTimePrice
    );

    if (subscription.length) subscription.html(subscriptionHTML);
    onetime.html(onetimeHTML);
  }

  updatePriceSettings(e) {
    let basePrice, discount;
    if (this.$variantSelector.length) {
      basePrice = this.$variantSelector.mfrVariantSelector("get-price");

      if (
        this.$subscriptionSelector.mfrSubscriptionSelector("selected-option") ==
        "subscription"
      ) {
        discount = this.$subscriptionSelector.length
          ? this.$subscriptionSelector.mfrSubscriptionSelector("get-discount")
          : 0;
      }
      else {
        discount = 0;
      }
    }

    this.$form.data("base-price", basePrice);
    this.$form.data("price-discount", discount);
  }

  updatePrice() {
    this.updatePriceSettings();
    if (!this.$price.length) return;
    const basePrice = parseFloat(this.$form.data("base-price"));
    const discount =
      this.$subscriptionSelector.length ? this.$subscriptionSelector.mfrSubscriptionSelector(
        "get-discount"
      ) : 0;
    const quantity = this.$quantitySelector.length
      ? this.$quantitySelector.mfrQuantitySelector("get-quantity")
      : 1;
    const currentPrice = (basePrice - basePrice * discount) * quantity;

    this.$price.html(
      `${this.$price.html()[0]}${this.toFixedIfNecessary(currentPrice, 2)}`
    );
  }

  toFixedIfNecessary(value, dp) {
    return +parseFloat(value).toFixed(dp);
  }

  positionPDPImage() {
    const containerMobile = $(".product-image-container-mobile");
    const containerDesktop = $(".cell.product-top__images");

    if(!this.$element) return ;

    this.$productImage = this.$element.find(this.selectors.productImage);

    // for positioning the pdp image on mobile
    if($(window).width() < 768 && containerMobile.length > 0) {
      this.$productImage.detach().appendTo(containerMobile);
    } else if(containerDesktop) {
      this.$productImage.detach().appendTo(containerDesktop);
    }

    $(window).on("resize", this.positionPDPImage);
  }

  changeImageOnSubscriptionSelect() {
    if (!this.$carousel.data("flickity")) return;

    const index = this.$element
      .find('[name="purchase_selector"]:checked')
      .data("image-index");
    this.$carousel.flickity("selectCell", index);
  }
}